// extracted by mini-css-extract-plugin
export default {"headerCard":"XmWRccWfxWe9Q5LEMYzv","headerTitleSection":"VCITnOU326gi8r1BJgPb","title":"a78abI6l_6dh4E7Myg6Z"};